import * as yup from 'yup';

declare module 'yup' {
  interface DateSchema<TType, TContext, TDefault, TFlags> {
    minDate(minDate: Date, message: string): this;
  }
}

const getDateWithoutTime = (date: Date): Date => {
  return new Date(date.setHours(0, 0, 0, 0));
};

yup.addMethod(yup.date, 'minDate', function (minDate: Date, message: string) {
  return this.test('minDateTest', message, function (date) {
    if (!date) {
      return true;
    }
    return getDateWithoutTime(date) >= getDateWithoutTime(minDate);
  });
});

export default yup;
